/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tall_Gold_Duck_KnitInputs */

const en_tall_gold_duck_knit = /** @type {(inputs: Tall_Gold_Duck_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const de_tall_gold_duck_knit = /** @type {(inputs: Tall_Gold_Duck_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Tall_Gold_Duck_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tall_gold_duck_knit = /** @type {((inputs?: Tall_Gold_Duck_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tall_Gold_Duck_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tall_gold_duck_knit(inputs)
	return de_tall_gold_duck_knit(inputs)
});